import OnboardingScene from './OnboardingScene';
import { OnbBody, OnbButton, OnbEyebrow, OnbHeadline } from './OnboardingType';

// Screen 3 — What Arvexis is / agency. Copy is the hero; the rows are informational only.
const InfoRow = ({ title, detail, index }) => (
  <div className="border-t border-white/10 pt-5 lg:pt-6 xl:pt-7" data-testid={`onboarding-agency-row-${index}`}>
    <p
      className="text-[0.86rem] lg:text-[1.25rem] xl:text-[1.45rem] text-white/88"
      style={{ fontFamily: '"Cormorant Garamond", Georgia, serif' }}
    >
      {title}
    </p>
    <OnbBody className="mt-2 lg:mt-3 !text-[0.78rem] lg:!text-[0.95rem] xl:!text-[1.02rem] text-white/55">{detail}</OnbBody>
  </div>
);

export const StepAgency = ({ copy: COPY, onContinue, onBack }) => (
  <OnboardingScene
    step={3}
    copy={COPY}
    align="end"
    objectClass="object-center"
    onBack={onBack}
    footer={
      <OnbButton onClick={onContinue} testId="onboarding-continue-btn-3">
        {COPY.continue}
      </OnbButton>
    }
  >
    <div className="max-w-[21rem] lg:w-[60%] lg:max-w-[46rem] xl:w-[50%] 2xl:w-[48%]">
      <OnbEyebrow testId="onboarding-eyebrow-3" tight={COPY.tightEyebrow}>{COPY.agency.eyebrow}</OnbEyebrow>
      <OnbHeadline testId="onboarding-headline-3" className="lg:!text-[2.35rem] xl:!text-[3rem] 2xl:!text-[3.4rem]">
        {COPY.agency.headline}
      </OnbHeadline>
      <OnbBody className="mt-5 lg:mt-6 xl:mt-8">{COPY.agency.body}</OnbBody>

      <div className="mt-9 space-y-5 lg:mt-9 lg:space-y-6 xl:mt-12 xl:space-y-8">
        {COPY.agency.rows.map((row, i) => (
          <InfoRow key={row.title} title={row.title} detail={row.detail} index={i + 1} />
        ))}
      </div>
    </div>
  </OnboardingScene>
);

export default StepAgency;
